import React, { useState } from "react";
import { Box, TextField, Button, Typography, Alert } from "@mui/material";
import { useAuth } from "../../context/AuthContext";
import Logo from "../../assets/logoazul.png";
import { validateEmail } from "../../utils/passwordValidation";

const RESEND_COOLDOWN_SEC = 60;

const GENERIC_SUCCESS =
    "Se existir uma conta com este e-mail, você receberá um link para redefinir sua senha. Verifique também a caixa de spam.";

export default function ForgotPasswordForm({ onBack }) {
    const { requestPasswordReset } = useAuth();

    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [cooldown, setCooldown] = useState(0);

    function startCooldown() {
        setCooldown(RESEND_COOLDOWN_SEC);
        const interval = setInterval(() => {
            setCooldown((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    }

    async function handleSubmit(e) {
        e?.preventDefault();
        if (loading || cooldown > 0) return;

        const emailError = validateEmail(email);
        if (emailError) {
            setErrorMessage(emailError);
            return;
        }

        setLoading(true);
        setErrorMessage("");

        const res = await requestPasswordReset(email);

        setLoading(false);

        if (!res.ok) {
            if (res.message) {
                setErrorMessage(res.message);
                return;
            }
            setErrorMessage("E-mail inválido. Verifique e tente novamente.");
            return;
        }

        setSubmitted(true);
        startCooldown();
    }

    return (
        <Box component="form" onSubmit={handleSubmit}>
            <img src={Logo} alt="logo" style={{ width: 150, marginBottom: 20 }} />

            <Typography variant="h5" sx={{ fontWeight: 700, textAlign: "start" }}>
                Redefinir senha
            </Typography>

            <Typography sx={{ mt: 1, mb: 3, opacity: 0.6, textAlign: "start", fontSize: 14 }}>
                Informe o e-mail da sua conta. Enviaremos um link seguro para criar uma nova senha.
            </Typography>

            {submitted && (
                <Alert severity="success" sx={{ mb: 2, textAlign: "left", borderRadius: 2 }}>
                    {GENERIC_SUCCESS}
                </Alert>
            )}

            {errorMessage && (
                <Alert severity="error" sx={{ mb: 2, textAlign: "left", borderRadius: 2 }}>
                    {errorMessage}
                </Alert>
            )}

            <TextField
                fullWidth
                type="email"
                placeholder="E-mail"
                margin="normal"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                disabled={loading}
                sx={{
                    "& .MuiInputBase-input::placeholder": { color: "#b5b5b5", opacity: 1 },
                }}
            />

            <Button
                fullWidth
                type="submit"
                variant="contained"
                disabled={loading || cooldown > 0}
                sx={{
                    mt: 3,
                    py: 1.4,
                    fontSize: 16,
                    borderRadius: "12px",
                    background: "var(--azul)",
                    ":hover": { background: "var(--azul)" },
                    opacity: loading || cooldown > 0 ? 0.7 : 1,
                }}
            >
                {loading
                    ? "Enviando..."
                    : cooldown > 0
                      ? `Reenviar em ${cooldown}s`
                      : submitted
                        ? "Reenviar link"
                        : "Enviar link"}
            </Button>

            <Typography
                sx={{
                    mt: 3,
                    textAlign: "center",
                    fontSize: 14,
                    cursor: "pointer",
                    textDecoration: "underline",
                    opacity: 0.8,
                }}
                onClick={onBack}
            >
                Voltar ao login
            </Typography>
        </Box>
    );
}
